import { useEffect, useState } from "react";
import { Input, Form, Button } from "antd";
import { BaseButtonsForm } from "components/common/forms/BaseButtonsForm";
import { notificationController } from "components/common/notificationController";
import SpinLoader from "components/Loader/SpinLoader";
import { useDispatch } from "react-redux";
// import { EcolabStoreList } from "redux/ecolabStore/types";
import { config } from "config/site.config";
import "react-phone-input-2/lib/style.css";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import {
  ecolabItemsString
} from "config/site.string";
import { addUpdateEcolabItemDetailsRequest } from "redux/ecolabItemDetails/actions";
dayjs.extend(utc);
dayjs.extend(timezone);
interface IAddUpdateItemDetailsForm {
  form: any;
  handleOk: any;
  isEdit: boolean;
  onClose: (isSuccess?: boolean) => void;
  handleCancel: () => void;
  selectedRecord: any;
}

export const EditEcolabItemDetails = ({
  form,
  isEdit,
  onClose,
  selectedRecord,
}: IAddUpdateItemDetailsForm) => {
  const dispatch = useDispatch();
  const [pending] = useState<boolean>(false);
  const currentUser = JSON.parse(
    localStorage.getItem("loggedInUser") || "null"
  );

  useEffect(() => {
    if (!isEdit) {
      form.resetFields();
    } else if (selectedRecord) {
      form.setFieldsValue({
        description: selectedRecord?.description,
        shortDescription: selectedRecord?.shortDescription,
        length: selectedRecord?.length,
        width: selectedRecord?.width,
        height: selectedRecord?.height
      });
    }
  }, [isEdit, selectedRecord, form]);

  const addItemCallback = (type: string, message: string) => {
    if (type === "Success") {
      notificationController.success({
        message: "Success",
        description: message
          ? message
          : `${
              isEdit ? `Item details updated successfully` : `Item details added successfully`
            }`,
        placement: "topRight",
      });
      form.resetFields();
      onClose(true);
    } else {
      notificationController.error({
        message: "Error",
        description: message ? message : "Sorry an error occurred",
        placement: "topRight",
      });
    }
  };

  const handleCancelButtonClick = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = (values: any) => {
    const itemValues: any = {
      id: isEdit ? selectedRecord?.id : null,
      description: values.description,
      shortDescription: values.shortDescription,
      length: values.length,
      width: values.width,
      height: values.height,
      updatedOn: new Date(),
      updatedBy: Number(currentUser?.userDetails?.userId),
      ...(isEdit
        ? {}
        : {
            createdOn: new Date(),
            createdBy: Number(currentUser?.userDetails?.userId),
          }),
    };

    dispatch(
      addUpdateEcolabItemDetailsRequest(
        config.addUpdateEcolabItemDetails,
        itemValues,
        addItemCallback
      )
    );
  };

  return (
    <>
      {pending ? (
        <SpinLoader />
      ) : (
        <>
          <BaseButtonsForm
            form={form}
            name="items"
            layout="vertical"
            style={{ padding: "12px 20px 0px" }}
            onFinish={handleSubmit}
            id="items"
          >
            <Form.Item
              name="description"
              label={ecolabItemsString.description}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="shortDescription"
              label={ecolabItemsString.shortDescription}
              rules={[
                {
                  required: true,
                  message: "Short description is required",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="length"
              label={ecolabItemsString.length}
              rules={[
                {
                  required: true,
                  message: "Length is required",
                },
              ]}
            >
               <Input type="number" />
            </Form.Item>
            <Form.Item
              name="width"
              label={ecolabItemsString.width}
              rules={[
                {
                  required: true,
                  message: "Width is required",
                },
              ]}
            >
               <Input type="number" />
            </Form.Item>
             <Form.Item
              name="height"
              label={ecolabItemsString.height}
              rules={[
                {
                  required: true,
                  message: "Height is required",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </BaseButtonsForm>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <Button
              type="primary"
              htmlType="submit"
              form="items"
              style={{ marginRight: 5 }}
            >
              SUBMIT
            </Button>
            <Button type="primary" onClick={handleCancelButtonClick}>
              CANCEL
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default EditEcolabItemDetails;

